// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CardPaymentDemo: MarkdocTagRegistration = {
  tag: 'card-payment-demo',
  component: 'CardPaymentDemo',
};
